module.exports = __webpack_public_path__ + "a2ad08ac8694bbd2cdcb619fd342560f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/tur.svg
// module id = 63
// module chunks = 0